import { useCallback, useState, MouseEvent, useEffect } from 'react';
import { ToggleButton, ToggleButtonGroup, ToggleButtonGroupProps } from '@mui/material';
import { GridFilterInputValueProps, useGridRootProps } from '@mui/x-data-grid-pro';
import type { GridApiPro } from '@mui/x-data-grid-pro/models/gridApiPro';

interface FilterToggleBooleanProps extends ToggleButtonGroupProps {
  allContent?: React.ReactElement;
  trueContent?: React.ReactElement;
  falseContent?: React.ReactElement;
}

export function FilterToggleBoolean(props: GridFilterInputValueProps & FilterToggleBooleanProps) {
  const { item, applyValue, apiRef: _apiRef, trueContent, falseContent, allContent, ...others } = props;
  const apiRef = _apiRef as React.MutableRefObject<GridApiPro>;
  const rootProps = useGridRootProps();
  const [filterValueState, setFilterValueState] = useState<boolean | ''>(item.value || '');

  const onFilterChange = useCallback(
    (event: MouseEvent<HTMLElement>, value?: boolean | '') => {
      setFilterValueState(value || '');
      applyValue({ ...item, value });
    },
    [applyValue, item]
  );

  useEffect(() => {
    setFilterValueState(item.value ?? 'all');
  }, [item.value]);

  return (
    <ToggleButtonGroup
      color='primary'
      size='small'
      value={filterValueState}
      exclusive
      disabled={rootProps.loading}
      onChange={onFilterChange}
      {...others}
    >
      <ToggleButton value={''} sx={{ flex: '1 1 auto' }}>
        <span>{allContent || 'All'}</span>
      </ToggleButton>
      <ToggleButton value={true} sx={{ flex: '1 1 auto' }}>
        {trueContent || apiRef.current.getLocaleText('filterValueTrue')}
      </ToggleButton>
      <ToggleButton value={false} sx={{ flex: '1 1 auto' }}>
        {falseContent || apiRef.current.getLocaleText('filterValueFalse')}
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
